import React from 'react';
import {
  reduxForm, InjectedFormProps, Field, formValueSelector,
} from 'redux-form';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { required, email, isImage } from '../../helpers/validate-forms';
import Input from '../Input/Input';
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import CenterInLine from '../Center/CenterInLine';
import FileInput from '../FileInput/FileInput';
import ImageForm from '../ImageForm/ImageForm';
import { RootState } from '../../redux/store';
import Select from '../Select/Select';
import UserDefault from '../../assets/img/user-photo-default.png';
import ContainerInputs from '../ContainerInputs/ContainerInputs';
import ContainerForm from '../ContainerForm/ContainerForm';
import FormRedux from '../FormRedux/FormRedux';
import Image from '../Image/Image';
import ContainerImageForm from '../ContainerImageForm/ContainerImageForm';
import { existEmail } from '../../helpers/async-validate-form';

const StudentForm: React.FC<InjectedFormProps> = ( props ) => {
  const selector = formValueSelector( 'student' );
  const { courses } = useSelector(( state: RootState ) => state.course );
  const photo = useSelector(( state: RootState ) => selector( state, 'photo' ));
  const {
    handleSubmit, submitting,
  } = props;

  return (
    <ContainerForm>
      <Grid item xs={12} sm={8}>
        <FormRedux
          onSubmit={handleSubmit}
        >
          <ContainerInputs>
            <Grid item xs={12} sm={6}>
              <Field
                name="identification"
                type="text"
                label="Identificación"
                component={Input}
                placeholder="Cédula del estudiante"
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="name"
                type="text"
                label="Nombres"
                component={Input}
                placeholder="Nombres del estudiante"
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="surname"
                type="text"
                label="Apellidos"
                component={Input}
                placeholder="Apellidos del estudiante"
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="email"
                type="text"
                label="Correo"
                component={Input}
                placeholder="Correo electrónico"
                validate={[required, email]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="representative"
                type="text"
                label="Representante"
                component={Input}
                placeholder="Nombre del representante"
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="phone"
                type="text"
                label="Teléfono"
                component={Input}
                placeholder="Número de contacto"
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="status"
                type="checkbox"
                component={Checkbox}
                title="Activo"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="courseId"
                component={Select}
                label="Curso"
                placeholder="Escoja un curso"
                validate={[required]}
                options={courses}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="photo"
                type="file"
                label="Elija una fotografía"
                component={FileInput}
                validate={[isImage]}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <CenterInLine>
                <Button type="submit" disabled={submitting}>
                  Enviar
                </Button>
              </CenterInLine>
            </Grid>
          </ContainerInputs>
        </FormRedux>
      </Grid>
      <Grid item xs={12} sm={4}>
        <CenterInLine>
          <ContainerImageForm>
            {photo
              ? <ImageForm photo={photo} />
              : <Image src={UserDefault} />}
          </ContainerImageForm>
        </CenterInLine>
      </Grid>
    </ContainerForm>
  );
};

export default reduxForm({
  form: 'student',
  asyncValidate: existEmail,
  asyncBlurFields: ['email'],
})( StudentForm );
